<!--
 * @Description: 零售快消行业：解决方案
-->
<template>
  <div
    class="retail_solution"
    :class="{
      'retail_solution_en': $i18n.locale === 'en_US','retail_solution_ja': $i18n.locale === 'ja_JP'
    }"
  >
    <div class="retail_content">
      <div class="solution_content" 
      >
        <!-- 左上 -->
        <div
          class="solution_position position title f_title f_title_center lt_f_title_1"
        >
          {{ $t("solution.retail.solutions.image.left_top_tab01.title") }}
        </div>
        <div
          class="solution_position position title s_title display_dir_col lt_s_title_1"
        >
          <div class="display_center lt_s_title_div">
            {{ $t("solution.retail.solutions.image.left_top_tab01.desc01") }}
          </div>
          <div class="display_center lt_s_title_div">
            {{ $t("solution.retail.solutions.image.left_top_tab01.desc02") }}
          </div>
          <div class="display_center lt_s_title_div">
            {{ $t("solution.retail.solutions.image.left_top_tab01.desc03") }}
          </div>
          <div class="display_center lt_s_title_div">
            {{ $t("solution.retail.solutions.image.left_top_tab01.desc04") }}
          </div>
        </div>
        <!-- 左上中 -->
        <div class="solution_position position ltc_1">
          <div class="solution_position title s_title">
            {{ $t("solution.retail.solutions.image.left_top_tab02.title") }}
          </div>
          <div class="solution_position title d_title ltc_desc_1">
            {{ $t("solution.retail.solutions.image.left_top_tab02.desc") }}
          </div>
        </div>
        <div class="solution_position position title s_title ltc_2">
          {{ $t("solution.retail.solutions.image.left_top_tab03.title") }}
        </div>
        <div class="solution_position position ltc_3">
          <div class="solution_position title s_title">
            {{ $t("solution.retail.solutions.image.left_top_tab04.title") }}
          </div>
          <div class="solution_position title d_title ltc_desc_1">
            {{ $t("solution.retail.solutions.image.left_top_tab04.desc") }}
          </div>
        </div>
        <!-- 左下 -->
        <div
          class="solution_position position title f_title f_title_center lb_f_title_1"
        >
          {{ $t("solution.retail.solutions.image.left_bottom_tab01.title") }}
        </div>
        <div
          class="solution_position position title s_title display_dir_col lb_s_title_1"
        >
          <div class="display_center lt_s_title_div">
            {{ $t("solution.retail.solutions.image.left_bottom_tab01.desc01") }}
          </div>
          <div class="display_center lt_s_title_div">
            {{ $t("solution.retail.solutions.image.left_bottom_tab01.desc02") }}
          </div>
          <div class="display_center lt_s_title_div">
            {{ $t("solution.retail.solutions.image.left_bottom_tab01.desc03") }}
          </div>
        </div>
        <!-- 左下中 -->
        <div class="solution_position position lbc_1">
          <div class="solution_position title s_title">
            {{ $t("solution.retail.solutions.image.left_bottom_tab02.title") }}
          </div>
          <div class="solution_position title d_title ltc_desc_1">
            {{ $t("solution.retail.solutions.image.left_bottom_tab02.desc") }}
          </div>
        </div>
        <div class="solution_position position title s_title lbc_2">
          {{ $t("solution.retail.solutions.image.left_bottom_tab03.title") }}
        </div>
        <div class="solution_position position title s_title lbc_3">
          <span class="bc_s_span">{{
            $t("solution.retail.solutions.image.left_bottom_tab04.title01")
          }}</span>
          <span>{{
            $t("solution.retail.solutions.image.left_bottom_tab04.title02")
          }}</span>
        </div>
        <!-- 右上 -->
        <div
          class="solution_position position title f_title f_title_center rt_f_title_1"
        >
          {{ $t("solution.retail.solutions.image.right_top_tab01.title") }}
        </div>
        <div
          class="solution_position position title s_title display_dir_col rt_s_title_1"
        >
          <div class="display_center lt_s_title_div">
            {{ $t("solution.retail.solutions.image.right_top_tab01.title01") }}
          </div>
          <div class="solution_position d_title rt_d_title_1">
            <div>
              <span class="rt_d_span">
                {{
                  $t("solution.retail.solutions.image.right_top_tab01.desc01")
                }}
              </span>
              <span>
                {{
                  $t("solution.retail.solutions.image.right_top_tab01.desc02")
                }}
              </span>
            </div>
            <div>
              <span class="rt_d_span">
                {{
                  $t("solution.retail.solutions.image.right_top_tab01.desc03")
                }}
              </span>
              <span>
                {{
                  $t("solution.retail.solutions.image.right_top_tab01.desc04")
                }}
              </span>
            </div>
            <div>
              <span class="rt_d_span">
                {{
                  $t("solution.retail.solutions.image.right_top_tab01.desc05")
                }}
              </span>
            </div>
          </div>
          <div class="display_center lt_s_title_div">
            {{ $t("solution.retail.solutions.image.right_top_tab01.title02") }}
          </div>
          <div class="display_center lt_s_title_div">
            {{ $t("solution.retail.solutions.image.right_top_tab01.title03") }}
          </div>
        </div>
        <!-- 右上中 -->
        <div class="solution_position position rtc_1">
          <div class="solution_position title s_title">
            {{ $t("solution.retail.solutions.image.right_top_tab02.title") }}
          </div>
          <div class="solution_position title d_title ltc_desc_1">
            {{ $t("solution.retail.solutions.image.right_top_tab02.desc") }}
          </div>
        </div>
        <div class="solution_position position title s_title rtc_2">
          {{ $t("solution.retail.solutions.image.right_top_tab03.title") }}
        </div>
        <div class="solution_position position rtc_3">
          <div class="solution_position title s_title">
            {{ $t("solution.retail.solutions.image.right_top_tab04.title") }}
          </div>
          <div class="solution_position title d_title ltc_desc_1">
            {{ $t("solution.retail.solutions.image.right_top_tab04.desc") }}
          </div>
        </div>
        <!-- 右下 -->
        <div
          class="solution_position position title f_title f_title_center rb_f_title_1"
        >
          {{ $t("solution.retail.solutions.image.right_bottom_tab01.title") }}
        </div>
        <div
          class="solution_position position title s_title display_dir_col rb_s_title_1"
        >
          <div class="display_center rb_s_title_div">
            {{
              $t("solution.retail.solutions.image.right_bottom_tab01.desc01")
            }}
          </div>
          <div class="display_center rb_s_title_div">
            {{
              $t("solution.retail.solutions.image.right_bottom_tab01.desc02")
            }}
          </div>
          <div class="display_center rb_s_title_div">
            {{
              $t("solution.retail.solutions.image.right_bottom_tab01.desc03")
            }}
          </div>
        </div>
        <!-- 右下中 -->
        <div class="solution_position position title s_title rbc_1">
          <div class="rbc_s_span">{{
            $t("solution.retail.solutions.image.right_bottom_tab02.title01")
          }}</div>
          <div class="rbc_s_span">{{
            $t("solution.retail.solutions.image.right_bottom_tab02.title02")
          }}</div>
          <div class="rbc_s_span">{{
            $t("solution.retail.solutions.image.right_bottom_tab02.title03")
          }}</div>
          <div class="rbc_s_span">{{
            $t("solution.retail.solutions.image.right_bottom_tab02.title04")
          }}</div>
          <div class="rbc_s_span">{{
            $t("solution.retail.solutions.image.right_bottom_tab02.title05")
          }}</div>
        </div>
        <div class="solution_position position title s_title rbc_2">
          <span class="bc_s_span">{{
            $t("solution.retail.solutions.image.right_bottom_tab03.title01")
          }}</span>
          <span>{{
            $t("solution.retail.solutions.image.right_bottom_tab03.title02")
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RetailFMCGSolution',
}
</script>